import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {getUser } from '../redux/userActions'

//const LOGIN_PATH = '/login'
const LOGIN_PATH = '/inCyberNotes/login'

class AuthComponent extends Component {
  componentDidUpdate() {
    const { userLoading, user } = this.props
    if (userLoading === false && !user) {
      this.props.history.push(LOGIN_PATH)
    }
  }

  // Note: always render a children inside a div
  render() {
    const { user, userLoading, children } = this.props
    return userLoading === false && user ? (
       <div> {children} </div>
    ) : (
      <div>
        <h1>Access Denied</h1>
      </div>
    )
  }
}

function mapState(state) {
  return {
    user: state.user,
    userLoading: state.loading.user
  }
}

export default withRouter(
  connect(mapState, { getUser })(AuthComponent)
)



// WEBPACK FOOTER //
// ./src/components/AuthComponent.js